var map = {
	"./azx-b.png": "2a53",
	"./azx.png": "59c7",
	"./bdlb-b.png": "16c4",
	"./bdlb.png": "a52a",
	"./bm-b.png": "805e",
	"./bm.png": "e5af",
	"./bx-b.png": "ef9d",
	"./bx.png": "5dd1a",
	"./fbfx-b.png": "b038",
	"./fbfx.png": "9942",
	"./ff-b.png": "7c12",
	"./ff.png": "09bd",
	"./fx-b.png": "ec0d",
	"./fx.png": "ecd0",
	"./idi-b.png": "2e39",
	"./idi.png": "88b1",
	"./jsqx-b.png": "7437",
	"./jsqx.png": "ac13",
	"./pf-b.png": "fcae",
	"./pf.png": "30e8",
	"./sjkb-b.png": "e9ba",
	"./sjkb.png": "4332",
	"./tis-b.png": "cab6",
	"./tis.png": "99f2",
	"./yhgl-b.png": "c8d5",
	"./yhgl.png": "a0c0",
	"./zz-b.png": "a383",
	"./zz.png": "1170"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1dc4";